// extracted by mini-css-extract-plugin
module.exports = {"empty_wrapper":"Update_empty_wrapper__SGDa9"};